import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el MEGAPACK TENIS RESUELTO después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a los 6 tomos y los 6 bonos en formato PDF. Acceso en menos de 5 minutos, desde cualquier dispositivo, para siempre. Sin suscripciones ni vencimientos.'
}, {
  q: '¿Sirve para entrenadores con poca experiencia o solo para los avanzados?',
  a: 'Sirve para todos. El Megapack tiene contenido desde el entrenador que recién empieza hasta el que trabaja con jugadores de competencia. Cada tomo indica claramente el nivel al que está dirigido y cómo adaptarlo a tu contexto.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Los tomos y bonos son PDF de uso personal. Las fichas y plantillas están diseñadas para imprimir y completar a mano o digitalmente. No se pueden redistribuir ni comercializar.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin costo adicional. El Pack Completo agrega además los 2 tomos del Tenis Pro Avanzado™.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para ambos. Hay módulos, plantillas y drills específicos tanto para clases individuales como para grupos de todos los tamaños. El contenido se adapta a tu formato de trabajo.'
}, {
  q: '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?',
  a: 'Sí, exactamente para eso fue diseñado. El Tomo 2 tiene un módulo completo de gestión de grupos por nivel y el Bono 2 tiene drills organizados por nivel para trabajar con grupos heterogéneos sin caos.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de tenis?',
  a: 'El Megapack Tenis Resuelto es el único sistema que cubre técnica, táctica, físico, mentalidad, planificación y negocio en un solo producto. No es un libro de tenis: es un sistema operativo completo para el entrenador. Cada recurso está pensado para usar directamente en cancha, no para estudiar en casa y olvidar.'
}, {
  q: '¿Por qué elegir el Pack Completo y no el estándar?',
  a: 'El Pack Completo agrega los 2 tomos de Tenis Pro Avanzado™ que cubren el tenis de competencia y el tenis infantil: los dos mercados más rentables para un entrenador. Si trabajás o querés trabajar con cualquiera de esos perfiles, la diferencia de inversión se recupera con el primer alumno.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si por cualquier motivo no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas. Menos del 1% de los compradores la usa.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 bg-white" data-id="element-80">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <h2 className="text-2xl md:text-4xl font-display text-navy-900 text-center mb-8 md:mb-12" data-id="element-82">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-gray-50" data-id="element-84">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-4 md:py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta" aria-expanded={openIndex === index} data-id="element-85">
                <span className="font-bold text-sm md:text-base text-navy-900 pr-4" data-id="element-86">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-87">
                  <ChevronDown className="w-5 h-5 text-terracotta flex-shrink-0" data-id="element-88" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-89">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-90">
                    <div className="px-4 md:px-6 pb-4 md:pb-5 text-sm md:text-base text-gray-600 leading-relaxed border-t border-gray-100 pt-3 md:pt-4" data-id="element-91">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}